import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker, useIntersectionObserver, numFormat, getBase64 } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';

import * as APIS from "../../utils/service";


export default function ReviewPage({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const location = useLocation();
    const selectFile = useRef(null);

    //console.log(location);
    const { configdata } = useSelector(s => s.configReducer);
    let reviewOptions = configdata?.consts?.reviewOptionConsts;
    //console.log(configdata);
    let type0filter = Object.keys(reviewOptions)?.filter(item => item.substring(0,3) !== 'not');
    let type1filter = Object.keys(reviewOptions)?.filter(item => item.substring(0,3) === 'not');

    //console.log(Object.keys(reviewOptions), type0filter, type1filter);
    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {labels: x?.title, values: x?.idx}
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {labels: x?.title, values: x?.idx, category_1: x?.category_1}
    })

    const [termlist, setconfigs] = useState(configdata?.consts?.reportselData);   
    const [files, setfiles] = useState([]);   



    
    const [memberinfos, setmemberinfos] = useState(''); 
    const [mediation, setmediation] = useState({}); 
    const [steps, setsteps] = useState(0); 

    const [type1, settype1] = useState(0); // 진행여부 0=아니오, 1=예
    const [type2, settype2] = useState(0); //만족여부 0=불만족, 1=만족
    const [kind, setkind] = useState(0); // 친절도 체크여부
    const [pro, setpro] = useState(0);  // 친절도 체크여부
    const [cooperative, setcooperative] = useState(0); // 협조적 체크여부
    const [conscientious, setconscientious] = useState(0); // 양심적 체크여부
    const [accurate, setaccurate] = useState(0); // 정확함 체크여부
    const [not_condition, setnot_condition] = useState(0); // 미진행시 조건이 맞지않습니다 체크여부
    const [not_transaction, setnot_transaction] = useState(0); // 미진행시 거래가 완료되었습니다 체크여부
    const [not_kind, setnot_kind] = useState(0);  // 미진행시 불친절합니다 체크여부
    const [not_cooperative, setnot_cooperative] = useState(0); // 미진행시 비협조적입니다 체크여부
    const [selectvalues, setselectvalues] = useState([]); // 미진행시 비협조적입니다 체크여부
    const [item, setitem] = useState({}); // 

    const [detailinfos, setdetailinfos] = useState([]);
    const [popflag, setpopflag] = useState(false);
    const [popcomments, setpopcomments] = useState(''); 
    const [errmsg, seterrmsg] = useState('');   
    const [title, settitle] = useState('');   
    
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
   
    useEffect(() => {
        getmedations();
    }, [location, memberinfos]);
    const getmedations = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            idx: location?.state?.review?.detail?.idx
        }
        console.log(sender);
        APIS.postData('/v1/mediation/get', sender).then(({ data }) => {
            if(data){
                console.log(data);
                // setrows(data?.row);
                // setnexts(data?.next);
                // setprevs(data?.prev);
                setmediation(data?.mediation);
                setitem(data?.item);
                let item = data?.item;
                let customer = data?.customer;

                let cate1Name = category_1_setting?.find((x, i) => (x?.values*1 === item['category_1']*1))?.labels;
                let cate2Name = category_2_setting?.find((x, i) => (x?.values*1 === item['category_2']*1))?.labels;

                console.log(data?.customer?.u_idx, memberinfos?.idx);
                let isCustomer = data?.customer?.u_idx == memberinfos?.idx;
                console.log("isCustomer:",isCustomer)
                if(isCustomer){
                    setdetailinfos([
                        {viewernames: '매물번호', values: item?.idx},
                        {viewernames: '거래형태', values: item?.sell_type},
                        {viewernames: '매물종류', values: cate1Name+" > "+cate2Name},
                        {viewernames: '전용면적', values: `${item?.area_private}㎡ (약 ${((item?.area_private*1)/3.3057).toFixed(2)}평)`},
                        {viewernames: '소재지 *지번 비공개', values: `${item?.sido} ${item?.sigungu} ${item?.dong}`},
                        {viewernames: '매매가', values: numFormat(item?.price_sell)+'만원'},
                        {viewernames: '보증금', values: numFormat(item?.price_all)+'만원'},
                        {viewernames: '월세', values: numFormat(item?.price_month)+'만원'},
                    ]); 
                } else {
                    setdetailinfos([
                        {viewernames: customer?.sell_type === '매매' ? '매매가' : '보증금', values: `${numFormat(customer?.price_all_min)}만원 ~ ${numFormat(customer?.price_all_max)}만원`},
                        {viewernames: '월세', values: `${numFormat(customer?.price_month_min)}만원 ~ ${numFormat(customer?.price_month_max)}만원`},
                        {viewernames: '희망 층수', values: `${numFormat(customer?.item_floor_min)}층 ~ ${numFormat(customer?.item_floor_max)}층`},
                        {viewernames: '희망 면적', values: `${numFormat(customer?.item_area_min)}㎡ ~ ${numFormat(customer?.item_area_max)}㎡`},
                        {viewernames: '희망 연식', values: `${customer?.item_year_min}년 ~ ${customer?.item_year_max}년`},
                        {viewernames: '입주시기', values: `${customer?.in_year} ${customer?.in_year_option1 ? '협의가능' : ''}  ${customer?.in_year_option2 ? '상관없음' : ''}`},
                    ]); 
                }
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });    
    }

    const reviewSubmit = () => {
        console.log(selectvalues);
        let sender = {
            idx: mediation?.idx,
            type1: type1,
            type2: type2,
            kind: selectvalues?.find((item) => item === 'kind') ? 1 : 0,
            pro: selectvalues?.find((item) => item === 'pro') ? 1 : 0,
            cooperative: selectvalues?.find((item) => item === 'cooperative') ? 1 : 0,
            conscientious: selectvalues?.find((item) => item === 'conscientious') ? 1 : 0,
            accurate: selectvalues?.find((item) => item === 'accurate') ? 1 : 0,
            not_condition: selectvalues?.find((item) => item === 'not_condition') ? 1 : 0,
            not_transaction: selectvalues?.find((item) => item === 'not_transaction') ? 1 : 0,
            not_kind: selectvalues?.find((item) => item === 'not_kind') ? 1 : 0,
            not_cooperative: selectvalues?.find((item) => item === 'not_cooperative') ? 1 : 0,
        }
        console.log(sender);
        //return;
        dispatch(loadingflas({ loading: true }));

        APIS.postData('/v1/mediation/review', sender).then(({ data }) => {
            if(data){
                setsteps(3);
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
            dispatch(
                open({
                    component: data?.msg,
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                    button: "확인",
                    onPress: () => {
                        dispatch(close());
                    }
                })
            ); 

        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });  

        //selectvalues?.find((item) => item === x)
        
    }

    const reportSubmit = () => {
        if(title === ''){
            seterrmsg('신고사유를 선택해주세요.');
            return;
        }
        if(popcomments === ''){
            seterrmsg('신고내용을 입력해주세요.');
            return;
        }

        let fileSetting = [];
        files?.map((x, i) => {
            //console.log(x);
            fileSetting.push({base: x?.base64, ext: x?.ext});
        });
        //return;
        let sender = {
            u_idx: mediation?.user?.idx,
            target_idx: mediation?.targetUser?.idx,
            title: title,
            desc: popcomments,
            files: fileSetting
        }
        dispatch(loadingflas({ loading: true }));

        APIS.postData('/v1/mediation/reportinsert', sender).then(({ data }) => {
            if(data){
                setpopflag(false);
            }
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: data?.msg,
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                    button: "확인",
                    onPress: () => {
                        dispatch(close());
                    }
                })
            ); 

        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });          
    }
    return(
        <Layout header={false} actives={''}>
            <div className='customercenter'>
                <div className='margint20 bolds fontsize24'>
                    만족도 평가하기
                </div>
                <div className='customercenterPage allround margint20'>
                    <div className='reviewArea'>
                        <div>
                            <div className='left_titlebuton'>
                                <div className='bolds'>공동중개</div>
                                <div>
                                    <button
                                        onClick={() => {
                                            setpopflag(true);
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                            <path d="M2.66797 13.833V9.83301C2.66797 6.88749 5.05579 4.49967 8.00132 4.49967C10.9469 4.49967 13.3347 6.88749 13.3347 9.83301V13.833H14.0013V15.1663H2.00131V13.833H2.66797ZM4.00131 13.833H12.0013V9.83301C12.0013 7.62387 10.2105 5.83301 8.00132 5.83301C5.79217 5.83301 4.00131 7.62387 4.00131 9.83301V13.833ZM7.33465 1.83301H8.66799V3.83301H7.33465V1.83301ZM13.1868 3.70475L14.1296 4.64756L12.7154 6.06177L11.7725 5.11896L13.1868 3.70475ZM1.87305 4.64756L2.81586 3.70475L4.23007 5.11896L3.28726 6.06177L1.87305 4.64756ZM4.66797 9.83301C4.66797 7.99207 6.16036 6.49967 8.00132 6.49967V7.83301C6.89672 7.83301 6.00131 8.72841 6.00131 9.83301H4.66797Z" fill="#FF0000"/>
                                        </svg>
                                        <span className='bolds'>신고하기</span>
                                    </button>
                                </div>
                            </div>
                            <div style={{ width: '100%' }}>
                                {mediation && <Profiles 
                                    profileimgs={true} mypages={true} memberinfosData={memberinfos?.idx*1 === mediation?.targetUser?.idx*1 ? mediation?.user : mediation?.targetUser} Trophyinfo={false} 
                                    profilesimgButtons={false}
                                />}
                            </div>
                            <div className='productinfoArea2' style={{ width: '100%' }}>
                                <div>
                                    <div className="title_txt bolds">상세 정보</div>
                                    <div className='infos'>
                                        {detailinfos?.length > 0 && detailinfos?.map((x, i) => {
                                            if(item?.sell_type === '매매'){
                                                if(x?.viewernames === '보증금' || x?.viewernames === '월세'){
                                                    return;
                                                }
                                            } else {
                                                if(x?.viewernames === '매매가'){
                                                    return;
                                                }
                                            }
                                            return (
                                                <div key={i}>
                                                    <div className='win150'>{x?.viewernames}</div>
                                                    <div>{x?.values}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            {steps === 0 &&
                                <>
                                <div className='bolds fontsize24'>중개사님과 공동중개를 진행하셨나요?</div>
                                <div className='popbuttons' style={{ width: '50%', marginTop: 0 }}>
                                    <div>
                                        <Button
                                            disabled={true}
                                            buttonTxt={'아니오'}
                                            onPress={() => { settype1(0); setsteps(1); }}
                                        />                                    
                                    </div>
                                    <div>
                                        <Button
                                            buttonTxt={'네'}
                                            onPress={() => { settype1(1); setsteps(1); }}
                                        />                                    
                                    </div>
                                </div>
                                </>
                            }
                            {steps === 1 && type1 === 1 &&
                                <>
                                <div className='bolds fontsize24'>공동중개 과정에 만족하셨나요?</div>
                                <div className='popbuttons' style={{ width: '50%', marginTop: 0 }}>
                                    <div>
                                        <Button
                                            disabled={true}
                                            buttonTxt={'아니오'}
                                            onPress={() => { settype2(0); setsteps(2); }}
                                        />                                    
                                    </div>
                                    <div>
                                        <Button
                                            buttonTxt={'네'}
                                            onPress={() => { settype2(1); setsteps(2); }}
                                        />                                    
                                    </div>
                                </div>
                                <div
                                    style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}
                                >
                                    <button 
                                        type="button"
                                        style={{ color: '#666', fontSize: 12}}
                                        onClick={() => { settype2(0); setsteps(0); }}
                                    >
                                        &lt; 뒤로가기
                                    </button>
                                </div>                                       
                                </>
                            }
                            {steps === 1 && type1 === 0 &&
                                <>
                                <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column'}} >
                                    <div className='bolds fontsize24'>진행하지 않은 이유는 무엇인가요?</div>
                                </div>
                                <div style={{ width: '80%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 8 }}>
                                    {type1filter?.map((x, i) => {
                                        let selflag = selectvalues?.find((item) => item === x);
                                        return (
                                            <button 
                                                key={i}
                                                style={{
                                                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                    borderRadius: 12, padding: 20,
                                                    backgroundColor: selflag ? '#6164A5' : '#F2F4F7'
                                                }}
                                                onClick={() => {
                                                    if(selectvalues?.find((item, index) => item === x)){
                                                        setselectvalues(selectvalues.filter(item => item !== x));
                                                    } else {
                                                        if(selectvalues?.length > 2){
                                                            return;
                                                        }
                                                        setselectvalues(selectvalues.concat(x));
                                                    }                                                    
                                                }}
                                            >
                                                <span className={`bolds fontsize16`} style={{ color: selflag ? '#fff' : '#333' }}>
                                                    {reviewOptions[x]?.title}
                                                </span>
                                                {selflag &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.4422 6.27614C13.9629 5.75544 13.9629 4.91122 13.4422 4.39052C12.9215 3.86983 12.0772 3.86983 11.5565 4.39052L7.16602 8.78105L5.44216 7.05719C4.92146 6.53649 4.07724 6.53649 3.55654 7.05719C3.03584 7.57789 3.03584 8.42211 3.55654 8.94281L6.22321 11.6095C6.7439 12.1302 7.58813 12.1302 8.10882 11.6095L13.4422 6.27614Z" fill="white"/>
                                                </svg>
                                                }
                                            </button>
                                        );
                                    })}
                                </div>
                                <div>
                                    <button
                                        style={{ 
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, 
                                            borderBottom: '1px solid #6164A5'

                                        }}
                                        onClick={() => { reviewSubmit(); }}
                                    >
                                        <span className={`bolds fontsize16 color6164A5`}>평가완료</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M13.4422 6.27614C13.9629 5.75544 13.9629 4.91122 13.4422 4.39052C12.9215 3.86983 12.0772 3.86983 11.5565 4.39052L7.16602 8.78105L5.44216 7.05719C4.92146 6.53649 4.07724 6.53649 3.55654 7.05719C3.03584 7.57789 3.03584 8.42211 3.55654 8.94281L6.22321 11.6095C6.7439 12.1302 7.58813 12.1302 8.10882 11.6095L13.4422 6.27614Z" fill="#6164A5"/>
                                        </svg>                                        
                                    </button>
                                </div>
                                <div
                                    style={{ width: '80%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}
                                >
                                    <button 
                                        type="button"
                                        style={{ color: '#666', fontSize: 12}}
                                        onClick={() => { settype2(0); setsteps(0); }}
                                    >
                                        &lt; 뒤로가기
                                    </button>
                                </div>                                    
                                </>
                            }      
                            {steps === 2 && type2 === 1 &&
                                <>
                                <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column'}} >
                                    <div className='bolds fontsize24'>어떤점이 만족스러웠나요?</div>
                                    <div className='color666 margint8'>최대 3개까지 선택 가능합니다.</div>
                                </div>
                                <div style={{ width: '80%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 8 }}>
                                    {type0filter?.map((x, i) => {
                                        let selflag = selectvalues?.find((item) => item === x);
                                        return (
                                            <button 
                                                key={i}
                                                style={{
                                                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                    borderRadius: 12, padding: 20,
                                                    backgroundColor: selflag ? '#6164A5' : '#F2F4F7'
                                                }}
                                                onClick={() => {
                                                    if(selectvalues?.find((item, index) => item === x)){
                                                        setselectvalues(selectvalues.filter(item => item !== x));
                                                    } else {
                                                        if(selectvalues?.length > 2){
                                                            return;
                                                        }                                                        
                                                        setselectvalues(selectvalues.concat(x));
                                                    }                                                    
                                                }}
                                            >
                                                <span className={`bolds fontsize16`} style={{ color: selflag ? '#fff' : '#333' }}>
                                                    {reviewOptions[x]?.true}
                                                </span>
                                                {selflag &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.4422 6.27614C13.9629 5.75544 13.9629 4.91122 13.4422 4.39052C12.9215 3.86983 12.0772 3.86983 11.5565 4.39052L7.16602 8.78105L5.44216 7.05719C4.92146 6.53649 4.07724 6.53649 3.55654 7.05719C3.03584 7.57789 3.03584 8.42211 3.55654 8.94281L6.22321 11.6095C6.7439 12.1302 7.58813 12.1302 8.10882 11.6095L13.4422 6.27614Z" fill="white"/>
                                                </svg>
                                                }
                                            </button>
                                        );
                                    })}
                                </div>
                                <div>
                                    <button
                                        style={{ 
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, 
                                            borderBottom: '1px solid #6164A5'

                                        }}
                                        onClick={() => { reviewSubmit(); }}
                                    >
                                        <span className={`bolds fontsize16 color6164A5`}>평가완료</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M13.4422 6.27614C13.9629 5.75544 13.9629 4.91122 13.4422 4.39052C12.9215 3.86983 12.0772 3.86983 11.5565 4.39052L7.16602 8.78105L5.44216 7.05719C4.92146 6.53649 4.07724 6.53649 3.55654 7.05719C3.03584 7.57789 3.03584 8.42211 3.55654 8.94281L6.22321 11.6095C6.7439 12.1302 7.58813 12.1302 8.10882 11.6095L13.4422 6.27614Z" fill="#6164A5"/>
                                        </svg>                                        
                                    </button>
                                </div>
                                <div
                                    style={{ width: '80%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}
                                >
                                    <button 
                                        type="button"
                                        style={{ color: '#666', fontSize: 12}}
                                        onClick={() => { settype2(0); setsteps(0); }}
                                    >
                                        &lt; 뒤로가기
                                    </button>
                                </div>                                 
                                </>
                            } 
                            {steps === 2 && type2 === 0 &&
                                <>
                                <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column'}} >
                                    <div className='bolds fontsize24'>어떤점이 불만족스러웠나요?</div>
                                    <div className='color666 margint8'>최대 3개까지 선택 가능합니다.</div>
                                </div>
                                <div style={{ width: '80%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 8 }}>
                                    {type0filter?.map((x, i) => {
                                        let selflag = selectvalues?.find((item) => item === x);
                                        return (
                                            <button 
                                                key={i}
                                                style={{
                                                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                    borderRadius: 12, padding: 20,
                                                    backgroundColor: selflag ? '#6164A5' : '#F2F4F7'
                                                }}
                                                onClick={() => {
                                                    if(selectvalues?.find((item, index) => item === x)){
                                                        setselectvalues(selectvalues.filter(item => item !== x));
                                                    } else {
                                                        if(selectvalues?.length > 2){
                                                            return;
                                                        }
                                                        setselectvalues(selectvalues.concat(x));
                                                    }                                                    
                                                }}
                                            >
                                                <span className={`bolds fontsize16`} style={{ color: selflag ? '#fff' : '#333' }}>
                                                    {reviewOptions[x]?.false}
                                                </span>
                                                {selflag &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.4422 6.27614C13.9629 5.75544 13.9629 4.91122 13.4422 4.39052C12.9215 3.86983 12.0772 3.86983 11.5565 4.39052L7.16602 8.78105L5.44216 7.05719C4.92146 6.53649 4.07724 6.53649 3.55654 7.05719C3.03584 7.57789 3.03584 8.42211 3.55654 8.94281L6.22321 11.6095C6.7439 12.1302 7.58813 12.1302 8.10882 11.6095L13.4422 6.27614Z" fill="white"/>
                                                </svg>
                                                }
                                            </button>
                                        );
                                    })}
                                </div>
                                <div>
                                    <button
                                        style={{ 
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, 
                                            borderBottom: '1px solid #6164A5'
                                        }}
                                        onClick={() => { reviewSubmit(); }}
                                    >
                                        <span className={`bolds fontsize16 color6164A5`}>평가완료</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M13.4422 6.27614C13.9629 5.75544 13.9629 4.91122 13.4422 4.39052C12.9215 3.86983 12.0772 3.86983 11.5565 4.39052L7.16602 8.78105L5.44216 7.05719C4.92146 6.53649 4.07724 6.53649 3.55654 7.05719C3.03584 7.57789 3.03584 8.42211 3.55654 8.94281L6.22321 11.6095C6.7439 12.1302 7.58813 12.1302 8.10882 11.6095L13.4422 6.27614Z" fill="#6164A5"/>
                                        </svg>                                        
                                    </button>
                                </div>
                                <div
                                    style={{ width: '80%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}
                                >
                                    <button 
                                        type="button"
                                        style={{ color: '#666', fontSize: 12}}
                                        onClick={() => { settype2(0); setsteps(0); }}
                                    >
                                        &lt; 뒤로가기
                                    </button>
                                </div>                                  
                                </>
                            }       

                            {steps === 3 &&
                                <>
                                <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column'}} >
                                    <div className='bolds fontsize24'>평가가 완료되었습니다.</div>
                                    
                                    <div className='color666 margint8 alignc'>
                                        {mediation?.targetUser?.compony?.title} / {mediation?.targetUser?.name} / {mediation?.targetUser?.rank}
                                    </div>
                                    <div className='color666 margint8 alignc'>
                                        
                                    </div>
                                </div>
                                {(type1 === 1 || type2 === 1) && 
                                <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column', width: '100%'}} >
                                    <div className='color666 margint8 alignc'>
                                    <b style={{ color: '#6164A5' }}>{mediation?.targetUser?.compony?.title} {mediation?.targetUser?.name} {mediation?.targetUser?.rank}님</b>을 즐겨찾기로 추가하면<br />
                                    공동중개 최상단에 <b style={{ color: '#6164A5' }}>{mediation?.targetUser?.compony?.title} {mediation?.targetUser?.name} {mediation?.targetUser?.rank}님</b>이 표시됩니다.
                                    </div>
                                    <div className='popbuttons' style={{ width: '70%', marginTop: 8 }}>
                                        <div style={{ width: '100%' }}>
                                            <Button
                                                buttonTxt={'즐겨찾기로 추가'}
                                                onPress={() => { 
                                                    let sender = {
                                                        target_idx: memberinfos?.idx*1 === mediation?.targetUser?.idx*1 ? mediation?.user?.idx*1 : mediation?.targetUser?.idx*1,
                                                    }
                                                    console.log(sender);
                                                    //return;
                                                    dispatch(loadingflas({ loading: true }));
                                            
                                                    APIS.postData('/v1/auth/favInsert', sender).then(({ data }) => {
                                                        if(data*1 > 0){
                                                            //console.log(data);
                                                            dispatch(
                                                                open({
                                                                    component: '즐겨찾기에 추가되었습니다.',
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                        navigate('/Favoritpage');
                                                                    }
                                                                })
                                                            ); 
                                                            
                                                        } else {
                                                            dispatch(
                                                                open({
                                                                    component: data,
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                    }
                                                                })
                                                            ); 
                                                        }
                                                    }).catch(({ response }) => {
                                                        const { data } = response;
                                                        console.log(data);
                                                    }).finally(() => {
                                                        dispatch(loadingflas({ loading: false }));
                                                    });  
                                                }}
                                            />                                    
                                        </div>
                                    </div>
                                </div>}
                                {(type1 === 0 || type2 === 0) && 
                                <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column', width: '100%'}} >
                                    <div className='color666 margint8 alignc'>
                                    <b style={{ color: '#6164A5' }}>{mediation?.targetUser?.compony?.title} {mediation?.targetUser?.name} {mediation?.targetUser?.rank}님</b>을 블랙리스트로 추가하면<br />
                                    공동중개에서 <b style={{ color: '#6164A5' }}>{mediation?.targetUser?.compony?.title} {mediation?.targetUser?.name} {mediation?.targetUser?.rank}님</b>이 제외됩니다.

                                    </div>
                                    <div className='popbuttons' style={{ width: '70%', marginTop: 8 }}>
                                        <div style={{ width: '100%' }}>
                                            <Button
                                                buttonTxt={'블랙리스트로 추가'}
                                                onPress={() => { 
                                                    let sender = {
                                                        target_idx: memberinfos?.idx*1 === mediation?.targetUser?.idx*1 ? mediation?.user?.idx*1 : mediation?.targetUser?.idx*1,
                                                    }
                                                    console.log(sender);
                                                    //return;
                                                    dispatch(loadingflas({ loading: true }));
                                            
                                                    APIS.postData('/v1/auth/blackInsert', sender).then(({ data }) => {
                                                        if(data*1 > 0){
                                                            //console.log(data);
                                                            dispatch(
                                                                open({
                                                                    component: '블랙리스트에 추가되었습니다.',
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                        navigate('/Blacklists');
                                                                    }
                                                                })
                                                            ); 
                                                        } else {
                                                            dispatch(
                                                                open({
                                                                    component: data,
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                    }
                                                                })
                                                            ); 
                                                        }
                                                    }).catch(({ response }) => {
                                                        const { data } = response;
                                                        console.log(data);
                                                    }).finally(() => {
                                                        dispatch(loadingflas({ loading: false }));
                                                    });  
                                                }}
                                                styles={{ backgroundColor: '#000' }}
                                            />                                    
                                        </div>
                                    </div>
                                </div>}
                                <div>
                                    <button
                                        style={{ 
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, 
                                            borderBottom: '1px solid #6164A5'
                                        }}
                                        onClick={() => { navigate(-1); }}
                                    >
                                        <span className={`bolds fontsize16 color6164A5`}>닫기</span>
                                    </button>
                                </div>
                                </>
                            }

                        </div>
                    </div>
                </div>
            </div>

            {popflag === true &&
            <div className='PopupArea'>
                <div>
                    <div className='PopupAreaBG' 
                        //onClick={() => { setpopflag(false); }}
                    />
                    <div className='PopupAreaContents' style={{ width: 600 }}>
                        <div>
                            <div className="popTitle padding20">
                                <span >신고하기</span>
                                <button
                                    onClick={() => {
                                        setpopflag(false);
                                    }}
                                >
                                    <img src="./images/icons/x.svg" width='20' />                                            
                                </button>
                            </div>
                            <div className="padding32">
                                <div className='popcontents'>
                                    <div style={{ width: '100%' }}>
                                        <div>
                                            신고 사유를 선택해주세요.
                                        </div>
                                        <div style={{ fontWeight: 700, marginTop: 20  }}>
                                            신고 사유<span style={{ color: 'red' }}>*</span>
                                        </div>
                                        <div>
                                            {termlist?.map((x, i) => {
                                                return (
                                                    <div key={i} className='register_checks' style={{ marginTop: 5}}>
                                                        <button type="button" 
                                                        onClick={() => { 
                                                            settitle(x?.title);
                                                        }}>
                                                            <img src={`./images/icons/BGM_${title === x?.title ? '': 'un'}check.svg`} style={{ width: 24, height: 24 }} />
                                                            <div>{x?.title}</div>
                                                        </button>
                                                    </div>                        
                                                );
                                            })}                                                 
                                        </div>
                                        <div style={{ fontWeight: 700, marginTop: 20  }}>
                                            신고 내용<span style={{ fontWeight: 400, color: '#333' }}>(500자 이하 상세하게 작성해 주세요.)</span><span style={{ color: 'red' }}>*</span>
                                        </div>                                        
                                        <div style={{ width: '100%', marginTop: 10 }}>
                                            <textarea
                                                onChange={(e) => {
                                                    setpopcomments(e.target.value);
                                                }}
                                                placeholder='내용을 입력해 주세요. (500자 이하)'
                                                style={{
                                                    width: '100%', height: 200, padding: 12,
                                                    borderRadius: 4, border: '1px solid #DDD'
                                                }}
                                            >{popcomments}</textarea>
                                        </div>

                                        <div className='normalform_comment' style={{ fontWeight: 700, marginTop: 20 }}>
                                            관련 이미지<span style={{ fontWeight: 400, color: '#333' }}>(1장 이상)</span>
                                        </div>
                                        <input type='file' ref={selectFile} style={{ display: 'none' }} onChange={(e) => {
                                            let file = e.target.files[0];
                                            getBase64(file).then(result => {
                                                file["base64"] = result;
                                                file["ext"] = file.name.split('.')[1];
                                                //console.log("File Is", file);
                                                //setfiles([...files, file]);
                                                let filesdata = [];
                                                filesdata.push(file);
                                                setfiles(filesdata);
                                                setfiles(files.concat(filesdata));
                                            })
                                            .catch(err => { console.log(err); });
                                        }} />

                                        <div className="write_image_list">
                                            {files?.length < 3 &&
                                            <button 
                                                type="button"
                                                onClick={() => {
                                                    selectFile.current.click();
                                                }}
                                            >
                                                <p>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M14.1053 13C14.1053 14.1579 13.1579 15.1053 12 15.1053C10.8421 15.1053 9.89474 14.1579 9.89474 13C9.89474 11.8421 10.8421 10.8947 12 10.8947C13.1579 10.8947 14.1053 11.8421 14.1053 13ZM22 10.8947V16.1579C22 18.7632 19.8684 20.8947 17.2632 20.8947H6.73684C4.13158 20.8947 2 18.7632 2 16.1579V10.8947C2 8.36842 3.97368 6.31579 6.44737 6.15789L7.76316 4.15789C8.26316 3.42105 9.07895 3 9.94737 3H14C14.8947 3 15.6842 3.44737 16.1842 4.15789L17.5 6.15789C20.0263 6.31579 22 8.36842 22 10.8947ZM16.2105 13C16.2105 10.6842 14.3158 8.78947 12 8.78947C9.68421 8.78947 7.78947 10.6842 7.78947 13C7.78947 15.3158 9.68421 17.2105 12 17.2105C14.3158 17.2105 16.2105 15.3158 16.2105 13ZM19.3684 9.84211C19.3684 9.26316 18.8947 8.78947 18.3158 8.78947C17.7368 8.78947 17.2632 9.26316 17.2632 9.84211C17.2632 10.4211 17.7368 10.8947 18.3158 10.8947C18.8947 10.8947 19.3684 10.4211 19.3684 9.84211Z" fill="#6164A5"/>
                                                </svg>             
                                                </p>
                                                <p>{files?.length}<span className='color999'>/3</span></p>
                                            </button>}
                                            {files?.map((x, i) => {
                                                return (
                                                    <div key={i} style={{ backgroundImage: `url(${x?.base64})`}}>
                                                        <button 
                                                            type="button"
                                                            onClick={() => {
                                                                setfiles(files?.filter((x2, i2) => i2 !== i));
                                                            }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                                <rect x="0.333984" width="16" height="16" rx="4" fill="#101010"/>
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M5.5683 5.23431C5.88072 4.9219 6.38725 4.9219 6.69967 5.23431L8.53398 7.06863L10.3683 5.23431C10.6807 4.9219 11.1873 4.9219 11.4997 5.23431C11.8121 5.54673 11.8121 6.05327 11.4997 6.36569L9.66536 8.2L11.4997 10.0343C11.8121 10.3467 11.8121 10.8533 11.4997 11.1657C11.1873 11.4781 10.6807 11.4781 10.3683 11.1657L8.53398 9.33137L6.69967 11.1657C6.38725 11.4781 5.88072 11.4781 5.5683 11.1657C5.25588 10.8533 5.25588 10.3467 5.5683 10.0343L7.40261 8.2L5.5683 6.36569C5.25588 6.05327 5.25588 5.54673 5.5683 5.23431Z" fill="white"/>
                                                            </svg>                
                                                        </button>
                                                    </div>
                                                );
                                            })}

                                        </div>                                        
                                    </div>
                                </div>
                                {errmsg &&
                                <div className='input_error ' style={{ width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                                    {errmsg}
                                </div>}
                                
                                <div className='popbuttons'>
                                    <div style={{ width: '100%' }}>
                                        <Button
                                            buttonTxt={'신고하기'}
                                            onPress={() => { 
                                                dispatch(
                                                    open({
                                                        component: '신고하시겠습니까?',
                                                        title: '신고하기',
                                                        button: "신고",
                                                        buttonCencle: "취소",       
                                                        titleviewer: true,                 
                                                        alert: false,
                                                        onPress: () => {
                                                            reportSubmit();
                                                            dispatch(close());
                                                        },
                                                        onCancelPress: () => {
                                                            dispatch(close());
                                                        }
                                                    })
                                                );  

                                                
                                            }}
                                        />                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            }
        </Layout>
    )
}

